import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import {
  CircularProgress,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import { toast } from "react-toastify";

import { downloadImageAs } from "../../../../infrastructure/utils/downloadImageAs";

const FORMAT_OPTIONS = [
  { value: "jpg", label: "JPG", hint: "حجم کمتر" },
  { value: "png", label: "PNG", hint: "کیفیت کامل" },
];

const ImageDownloadButton = ({ src, fileName, size = "small", sx }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [downloading, setDownloading] = useState(false);

  const stop = (event) => {
    event.stopPropagation();
  };

  const handleOpen = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const handleDownload = async (event, format) => {
    event.stopPropagation();
    setAnchorEl(null);
    setDownloading(true);
    try {
      await downloadImageAs(src, format, fileName);
    } catch {
      toast.error("دانلود تصویر انجام نشد. دوباره تلاش کنید.");
    } finally {
      setDownloading(false);
    }
  };

  if (!src) return null;

  return (
    <>
      <Tooltip title="دانلود تصویر">
        <span onClick={stop} onMouseDown={stop}>
          <IconButton
            size={size}
            color="primary"
            disabled={downloading}
            onClick={handleOpen}
            aria-label="دانلود تصویر"
            sx={{
              border: 1,
              borderColor: "divider",
              borderRadius: 1.5,
              bgcolor: "background.paper",
              "&:hover": { bgcolor: "background.paper" },
              ...sx,
            }}
          >
            {downloading ? (
              <CircularProgress size={18} />
            ) : (
              <DownloadOutlinedIcon fontSize="small" />
            )}
          </IconButton>
        </span>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={stop}
      >
        {FORMAT_OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            dense
            onClick={(event) => handleDownload(event, option.value)}
          >
            <ListItemText primary={`دانلود ${option.label}`} secondary={option.hint} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

ImageDownloadButton.propTypes = {
  src: PropTypes.string,
  fileName: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium"]),
  sx: PropTypes.object,
};

export default ImageDownloadButton;
